module.exports = __webpack_public_path__ + "img/re2.78b7e5e7.jpg";